<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "BildungsportalContact",
  props: ["materialId", "materialName"],
  data: () => ({
    formValid: false,
    firstNameRules: [
      v => !!v || "Bitte geben Sie Ihren Vornamen an",
    ],
    lastNameRules: [
      v => !!v || "Bitte geben Sie Ihren Nachnamen an",
    ],
    emailRules: [
      v => !!v || "Bitte geben Sie Ihre E-Mail Adresse an",
      v => /.+@.+\..+/.test(v) || "E-Mail Adresse ist nicht gültig",
    ],
    messageRules: [
      v => !!v || "Bitte geben Sie Ihre Nachricht an",
    ],
    contactForm: {
      submitted: false,
      firstname: "",
      name: "",
      phone: "",
      mail: "",
      bildungseinrichtung: "",
      jahrgangsstufe: "",
      message: "",

    },
  }),
  computed: {
    ...mapGetters("user", ["userEmail", "username"]),
    enableSubmitButton() {
      return !!this.contactForm.firstname &&
          !!this.contactForm.name.trim() &&
          !!this.contactForm.mail.trim() &&
          !!this.contactForm.message.trim();
    },
    placeholder() {
      return this.materialName ? `Ich möchte Angebot "${this.materialName}" in Anspruch nehmen.\nVielen Dank im Vorraus` : "";
    },
    title() {
      return this.materialName ?  "Angebot beanspruchen" : "Kontakt";
    },
    subtitle() {
      if(this.materialName) {
        return "Das Angebot kann kostenfrei beantragt werden und wird im Anschluss für Sie zeitnah freigegeben."
      } else {
        return "Sie haben Fragen zu unseren Materialien, möchten Feedback geben oder ein individuelles Anliegen besprechen? Dann schreiben Sie uns gern über das Kontaktformular – wir freuen uns auf Ihre Nachricht und melden uns schnellstmöglich zurück. "
      }
    }
  },
  methods: {
    ...mapActions("bildungsportal", ["sendContactMail"]),
    async onContactFormSubmit() {
      await this.sendContactMail(this.contactForm);
      this.contactForm.submitted = true;
    }
  }
}
</script>

<template>
    <v-card>
      <v-card-title style="padding-bottom: 4px">
        <div v-if="!contactForm.submitted" class="text-h5 font-weight-bold py-2"
             style="width: 100%">
          {{ title }}
        </div>
      </v-card-title>
      <v-card-text>
        <p v-if="!contactForm.submitted" style="margin-bottom: 24px; margin-top: 0" >{{ subtitle }}</p>
        <v-form v-if="!contactForm.submitted" @submit.prevent="onContactFormSubmit" v-model="formValid">
          <v-row class="contact-row" no-gutters>
            <v-col cols="12" sm="6" class="contact-col">
              <v-text-field
                  label="Ihr Vorname *"
                  :rules="firstNameRules"
                  v-model="contactForm.firstname"
                  filled
                  dense
                  background-color="#F1CBDB"
                  required />
            </v-col>
            <v-col cols="12" sm="6" class="contact-col">
              <v-text-field
                  label="Ihr Nachname *"
                  :rules="lastNameRules"
                  v-model="contactForm.name"
                  filled
                  dense
                  required />
            </v-col>
            <v-col cols="12" sm="6" class="contact-col">
              <v-text-field
                  label="Ihre Telefonnummer"
                  v-model="contactForm.phone"
                  filled
                  dense
                  background-color="#B4005520" />
            </v-col>
            <v-col cols="12" sm="6" class="contact-col">
              <v-text-field
                  label="Ihre E-Mail Adresse *"
                  v-model="contactForm.mail"
                  :rules="emailRules"
                  filled
                  dense
                  background-color="#B4005520"
                  required />
            </v-col>
            <v-col cols="12" sm="6" class="contact-col">
              <v-text-field
                  label="Ihre Bildungseinrichtung"
                  v-model="contactForm.bildungseinrichtung"
                  filled
                  dense
                  background-color="#B4005520"
                  required />
            </v-col>
            <v-col cols="12" sm="6" class="contact-col">
              <v-text-field
                  label="Ihre Jahrgangsstufe"
                  v-model="contactForm.jahrgangsstufe"
                  filled
                  dense
                  background-color="#B4005520" />
            </v-col>
            <v-col cols="12" class="contact-col">
              <v-textarea
                  label="Ihre Nachricht *"
                v-model="contactForm.message"
                  :rules="messageRules"
                  filled
                dense
                background-color="#B4005520"
                :placeholder="placeholder"
                required />
            </v-col>
          </v-row>
          <div style="padding-left: 8px; padding-top: 20px">
            <v-btn color="primary" class="mx-auto px-10" type="submit" :disabled="!enableSubmitButton">
              Abschicken
            </v-btn>
          </div>
        </v-form>
        <div v-else class="text-center">
          <v-icon x-large class="circle-icon">
            $bildungsportalDashboard
          </v-icon>
          <div class="text-center font-weight-bold text-h4 my-5">Vielen Dank!</div>
          <p>Ihre Anfrage ist bei uns eingegangen. Wir melden uns schnellstmöglich bei Ihnen zurück</p>
        </div>
      </v-card-text>
    </v-card>
</template>

<style scoped>
.circle-icon {
  height: 75px !important;
  width: 75px !important;
  border-radius: 50%;
  background: transparent linear-gradient(222deg, #931880 0%, #B40055 100%) 0% 0% no-repeat padding-box;
}

.contact-col {
  padding: 4px 8px !important;
}
</style>
